// extracted by mini-css-extract-plugin
export default {"titleName":"qnawrite_titleName__4-Tnh","title":"qnawrite_title__MraaZ"};